var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "briefs-tab-content-view" },
    [
      _vm.isDrilledIn
        ? _c("BriefContentView", {
            attrs: { "brief-id": _vm.selectedBriefId },
            on: {
              onSelectedItems: function ($event) {
                return _vm.$emit("onSelectedItems", $event)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "breadcrumb",
                  fn: function ({ title }) {
                    return [
                      _c("FolderBreadcrumb", {
                        attrs: {
                          breadcrumbs: [
                            {
                              id: _vm.selectedBriefId,
                              text: title || _vm.selectedBriefName,
                            },
                          ],
                          "home-title": "All briefs",
                        },
                        on: { goTo: _vm.goToList },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              25041331
            ),
          })
        : _c("BriefsListPane", { on: { select: _vm.onBriefSelected } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }